export default __webpack_public_path__ + "static/media/SD-highlets-border.8480e61b.png";